import { capitalize } from "lodash";
import Select from "react-select";
import { daySelectOptions } from "../../constant/attractor-select";
import { useState } from "react";

import { KioskAttractorType } from "../../types";
import DateComponent from "../../components/DateComponents";
import { useColors } from "../../provider/colors-provider";
import moment from "moment";

const SettingsContainer = ({
  data,
  openSettings,
  setOpenSettings,
  hideCloseButton,
  hideDeleteButton,
  submitText,
  cancelText,
  handleSubmit,
  handleDelete,
  handleClose,
}: {
  data: KioskAttractorType;
  openSettings: boolean;
  setOpenSettings: (arg: boolean) => void;
  hideCloseButton?: boolean;
  hideDeleteButton?: boolean;
  submitText?: string;
  cancelText?: string;
  handleSubmit: (arg: any) => void;
  handleDelete: (id: string | number) => void;
  handleClose: () => void;
}) => {
  const { primary } = useColors();
  const [startDate, setStartDate] = useState<any>(data.startDateEpoch);
  const [endDate, setEndDate] = useState<any>(data.endDateEpoch);
  const [endDateManuallyChanged, setEndDateManuallyChanged] =
    useState<boolean>(false);
  const [selected, setSelected] = useState<any>(
    data.dayVisibility
      ?.split(",")
      .map((val) => ({ value: val, label: capitalize(val) }))
  );

  const [showEveryday, setShowEveryday] = useState<any>(false);

  const handleUpdate = () => {
    handleSubmit({
      startDate,
      endDate,
      selected,
    });
    setOpenSettings(!openSettings);
  };

  return (
    <div>
      <div className="my-2">
        <p className="text-sm font-bold my-2">START DATE:</p>{" "}
        <DateComponent
          value={startDate}
          setter={(date: any) => {
            // Check if start date is after end date
            if (endDate && date > endDate) {
              alert(
                "Start date should be before or equal to end date. Setting to 1 day before end date."
              );
              // Set start date to 1 day before end date
              const adjustedStartDate = moment(endDate)
                .subtract(1, "day")
                .toDate();
              setStartDate(adjustedStartDate);
              return;
            }
            setStartDate(date);
            // Only auto-set end date if it hasn't been manually changed
            if (!endDateManuallyChanged) {
              const minimumEndDate = moment(date).add(14, "days").toDate();
              setEndDate(minimumEndDate);
            }
          }}
        />
      </div>{" "}
      <div className="my-2">
        <p className="text-sm font-bold my-2">END DATE:</p>{" "}
        <DateComponent
          value={endDate}
          setter={(date: any) => {
            if (date <= startDate) {
              alert("End date should be greater than start date");

              const minimumEndDate = moment(startDate).add(14, "days").toDate();

              setEndDate(minimumEndDate);

              return;
            }
            setEndDate(date);
            setEndDateManuallyChanged(true);
          }}
        />
      </div>
      <div className="my-2 flex gap-4 items-center justify-between">
        <p className="text-sm font-bold">SHOWING DAYS:</p>
        <span className="flex items-center gap-2">
          <p className="text-sm font-bold">SHOW EVERYDAY:</p>
          <input
            checked={showEveryday}
            onChange={(e) => {
              if (e.target.checked) {
                setSelected(daySelectOptions);
                setShowEveryday(true);
              }
              if (!e.target.checked) {
                setSelected([]);
                setShowEveryday(false);
              }
            }}
            id="checked-checkbox"
            type="checkbox"
            className="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600"
          />
        </span>
      </div>
      <div className="my-2">
        {/* <p className="text-sm font-bold my-2">CUSTOM DAYS:</p> */}
        <span>
          <Select
            isDisabled={showEveryday}
            isMulti
            value={selected}
            options={daySelectOptions}
            onChange={(newValue) => setSelected(newValue)}
          />
        </span>
      </div>
      <div className="my-2 flex flex-row gap-6 justify-between">
        <button
          onClick={handleUpdate}
          type="button"
          className="w-full rounded-md bg-primary-900 px-2.5 py-1.5 text-sm font-semibold text-white shadow-sm hover:bg-primary-600 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2"
          style={{
            background: primary,
          }}
        >
          {submitText || "Update"}
        </button>

        {!hideCloseButton && (
          <button
            onClick={() => {
              setOpenSettings(!openSettings);
              handleClose();
            }}
            type="button"
            className="w-full rounded-md bg-gray-400 px-2 py-1 text-sm font-semibold text-white shadow-sm hover:bg-gray-300"
          >
            {cancelText || "Close"}
          </button>
        )}
        {!hideDeleteButton && (
          <button
            onClick={() => {
              const confirmDelete = window.confirm(
                "Are you sure you want to delete this attractor?"
              );
              if (confirmDelete) handleDelete(data.attractorId);
            }}
            type="button"
            className="w-full rounded-md bg-red-50 px-2 py-1 text-sm font-semibold text-red-600 shadow-sm hover:bg-red-100"
          >
            Delete
          </button>
        )}
      </div>
    </div>
  );
};

export default SettingsContainer;
